<div class="Subscribetoregister">
<div class="modal-header">
    <h5 class="modal-title">Login</h5>
    <button type="button" class="btn-close closeme" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
    Please Login to your account to Subscribe or Register if you do not have an account.
</div>
<div class="modal-footer">
    <a class="btn btn-secondary" (click)="proceedWithLogin()">
        <b>LOGIN</b>
    </a>
    <button type="button" class="btn btn-primary " data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close">
        <b>CANCEL</b>
    </button>
</div>
</div>